import { showPercentage } from '@util/helper';
import { useMemo } from 'react';
import styled from '@emotion/styled';

interface Props {
  minted: number;
  total: number;
}

const BarContainer = styled.div`
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.8);
`;

function ProgressBar(props: Props): JSX.Element {
  /* Define state / hook */
  const { minted, total } = props;

  /* Custom Data Object for render or other usages */
  const percentage = (minted / total) * 100;

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */
  const Bar = useMemo(
    () => styled.div`
      width: ${percentage}%;
      background-color: var(--primary-color3);
    `,
    [percentage]
  );

  /* Render */
  return (
    <>
      <BarContainer className="progress mt-3">
        <Bar className="progress-bar" role="progressbar" />
      </BarContainer>
      <div>
        <p className="center">
          {`${showPercentage(percentage)} (${minted || 0} / ${total})`}
        </p>
      </div>
    </>
  );
}

export default ProgressBar;
